import Marketing from '@/pages/Marketing'
import Invite from '@/pages/Invite'
import Sign from '@/pages/Sign'
import Check from '@/pages/Check'
import SignSuccess from '@/pages/SignSuccess'
import CheckSuccess from '@/pages/CheckSuccess'
import ImgAd from '@/pages/ImgAd'
import JumpApp from '@/pages/JumpApp'
import ElePage from '@/pages/ElePage'
import ActivityPage from '@/pages/ActivityPage'

const marketingRoute: IRouter[] = [
  {
    path: 'marketing',
    element: <Marketing />,
  },
  {
    path: 'invite',
    element: <Invite />,
  },
  {
    path: 'sign',
    element: <Sign />,
  },
  {
    path: 'signsuccess',
    element: <SignSuccess />,
  },
  {
    path: 'check',
    element: <Check />,
  },
  {
    path: 'checksuccess',
    element: <CheckSuccess />,
  },
  {
    path: 'imgad',
    element: <ImgAd />,
  },
  {
    path: 'jumpApp',
    element: <JumpApp />,
  },
  {
    path: 'elePage',
    element: <ElePage />,
  },
  {
    path: 'landing',
    element: <ActivityPage />,
  },
]

export default marketingRoute
